{
  "UnifiedNavigation": "In Experience Cloud navigieren",
  "adobeExperienceCloudNoOrgsSelect": "Anderes Unternehmenskonto auswählen",
  "help": "Hilfe",
  "ok": "OK",
  "profile": "Profil",
  "searchButton": "Suchen",
  "sidenavMenuCloseTooltip": "Menü schließen",
  "sidenavMenuLockTooltip": "Zum Sperren des Menüs klicken",
  "solutionSwitcher": "Zu anderer Lösung wechseln",
  "themeCoachMark": "Helles Design",
  "themeCoachMarkMessage": "Die Experience Cloud-Kopfzeile unterstützt jetzt helles und dunkles Design. Klicken Sie auf Ihren Avatar, um Ihr bevorzugtes Design auszuwählen.",
  "toggleSideNav": "Seitliches Navigationsmenü ein-/ausblenden"
}
